import { Modal } from 'antd';
import { func } from 'prop-types';
import React from 'react';
import service from '../services'
import fetch from '../services/fetch';
import utils from '../utils';

export default class Sso extends React.Component {

    constructor(props) {
        super(props)
    }

    async componentDidMount() {
        // service.account.website().then(data => {
        //     sessionStorage.setItem('website', JSON.stringify(data));
        //     document.title = data.systemName;
        //     this.setState(Object.assign({}, this.state, data));
        // });

        let data = await service.account.website();
        
        sessionStorage.setItem('website', JSON.stringify(data));
        document.title = data.systemName;
        this.setState(Object.assign({}, this.state, data));

        const url = window.location.hash;
        // let ssoUrl = 'sso/login';
        let index = url.indexOf('?');
        let pageId = 0
        if(index > -1) {
            ssoUrl = ssoUrl +  url.substr(index);
            pageId = url.substr(url.indexOf('pageId=')+7);
        }
        let jumpUrl;
        if(url.indexOf('jumpUrl=') >= 0){
            jumpUrl = url.substr(url.indexOf('jumpUrl=')+8);
        }
        console.log(jumpUrl)
        fetch.get(ssoUrl).then(response => {
            if(response.code === 200) {
                let data =  this.transform(response);
                
                if(data.success) {
                    let payload = this.saveSession(data);
                    if(payload) {
                        this.props.updateAccount(payload);
                    }
                }
                console.log('单点...', data.payload.account)
                if(jumpUrl){
                    window.location.hash = jumpUrl
                    return
                }
                if(data.payload.account.schoolName === '宁波卫生职业技术学院'){
                    let myHash = "/datav/index/"+escape('http://zlgl.nchs.edu.cn/supervise/#/supvtaskAssign/querymytask');
                    console.log(myHash)
                    window.location.hash = myHash
                    console.log('完成跳转了',myHash)
                    return
                }
                if(1 == pageId ){
                    window.location.hash = "/employee/edit/index"
                }else if(2 == pageId){
                    window.location.hash = "/file/index/72";
                }else if(3 == pageId){
                    window.location.hash = "/file/index/73"
                }else if(4 == pageId){
                    window.location.hash = "/file/index/74"
                }else if(5 == pageId){
                    window.location.hash = "/file/index/75"
                }else if(6 == pageId){
                    window.location.hash = "/file/index/76"
                }else if(7 == pageId){
                    window.location.hash = '/supvtaskcreate/index'
                }else if(8 == pageId){
                    window.location.hash = '/supvtaskapproval/index'
                }else if(9 == pageId){
                    window.location.hash = "/supvtaskactive/index"
                }else if(10 == pageId){
                    window.location.hash = "/supvtasksummary/index"
                }else if(11 == pageId){
                    window.location.hash = '/supvtaskaudit/index'
                }else if(12 == pageId){
                    window.location.hash = '/supvtaskend/index'
                }else if(13 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xxjbqk.html')
                }else if(14 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xxzs.html')
                }else if(15 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xxjxtr.html')
                }else if(16 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xxjx.html')
                }else if(17 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xyjbqk.html')
                }else if(18 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xyzs.html')
                }else if(19 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xyjx.html')
                }else if(20 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/zycm.html')
                }else if(21 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/kccm.html')
                }else if(22 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xscm.html')
                }else if(23 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/xscm.html')
                }else if(24 == pageId){
                    window.location.hash = "/datav/index/"+escape('http://zg.cqyu.edu.cn/edu-datav-html/top50.html')
                }
                else{
                    window.location.hash = "/";
                }
            } else {
                setTimeout(function (){
                    window.location.hash = "/";
                    window.location.reload();
                },3000)
            }
        });
    }

    transform(response) {
        const data = response.payload.data;
        
        return {
            success: true,
            code: response.code,
            message: response.message,
            payload: {
            account: {
                id: data.employeeId,
                loginName: data.loginName,
                realName: data.realName,
                orgName : data.orgXzName,
                orgId : data.orgXzId,
                schoolName: data.schoolName,
                termName: data.termName,
                yearName: data.yearName,
                termId: data.termId,
                yearId: data.yearId,
                dudao: data.dudao,
                userType: data.userType,
                systemName: data.systemName
            },
            rules: data.roleModuleList.map((rule) => {
                if((rule.url || "").indexOf('/datav/index/') !== -1) {
                    var link = rule.url.split('/datav/index/')[1];
                    if(link) {
                        rule.url = "/datav/index/"+escape(link);
                    }
                }
                return {
                    id: rule.id,
                    name: rule.name,
                    pid: rule.pid,
                    url: rule.url,
                    depth: rule.level,
                    icon: rule.icon,
                    label: rule.label,
                    orderNum: rule.orderNum
                }
            }),
            roleIds: data.roleIds,
            }
        };
    }
    
    // saveSession(data) {
    //     var result = utils.tree(data.payload.rules);
    //     window.sessionStorage.setItem('session', JSON.stringify({
    //         account: data.payload.account,
    //         rules: result[0].children
    //     }));
        
    //     return data.payload;
    // }

    saveSession (data) {
        var result = utils.tree(data.payload.rules);
        const operation = {};
        window.sessionStorage.setItem('session', JSON.stringify({
            account: data.payload.account,
            rules: result[0].children,
            roleIds: data.payload.roleIds,
            operation: operation
        }));
        
        return data.payload;
    }

    render() {
        return (
            <div>
                登陆中。。。        
            </div>
        );
    }
}